import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, runtimeCss as _runtimeCss, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("rating-summary__ratingcontainer-3489pf", {
  display: "flex",
  gap: "4px",
  alignItems: "center",
  flexDirection: "row"
});
const _staticStyles2 = _cssRef("rating-summary__starswrapper-3ip38w", {
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  gap: "4px"
});
import React from 'react';
import { StarRating } from '../../primitives/star-rating';
import Skeleton from '../../primitives/skeleton';
import { breakpoints } from '../../primitives/tokens';
interface RatingSummaryProps {
  rating: number;
  count: number;
  smallSize?: boolean;
}
const styles = {
  ratingContainer: _staticStyles,
  ratingContainerSmall: (smallSize: boolean) => _runtimeCss({
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    flexDirection: 'row',
    [breakpoints.tb]: {
      flexDirection: smallSize ? 'column' : 'row'
    }
  }),
  starsWrapper: _staticStyles2,
  ratingText: (smallSize: boolean) => _runtimeCss({
    marginTop: '4px',
    fontWeight: 700,
    fontSize: smallSize ? '12px' : undefined,
    lineHeight: smallSize ? '16px' : undefined
  }),
  reviewsText: (smallSize: boolean) => _runtimeCss({
    paddingLeft: '4px',
    fontSize: '12px',
    lineHeight: '16px',
    textAlign: 'left',
    marginTop: '4px',
    whiteSpace: 'nowrap',
    [breakpoints.tb]: {
      marginTop: smallSize ? '0' : '4px'
    }
  })
};
const RatingSummary: React.FC<RatingSummaryProps> = ({
  rating,
  count,
  smallSize = false
}) => {
  if (typeof rating !== 'number' || typeof count !== 'number') {
    return null;
  }
  const starSize = smallSize ? 15 : 22;
  return <Skeleton>
            <div {..._mergeProps({
      css: _runtimeCss(styles.ratingContainerSmall(smallSize))
    })}>
                <div {..._mergeProps({
        css: styles.starsWrapper
      })}>
                    <StarRating variant="rated" rating={rating} size={starSize} />
                    <span {..._mergeProps({
          css: _runtimeCss(styles.ratingText(smallSize))
        })}>
                        {rating.toFixed(1)}
                    </span>
                </div>
                <div {..._mergeProps({
        css: _runtimeCss(styles.reviewsText(smallSize))
      })}>
                    (
                    {count}
                    {' '}
                    reviews)
                </div>
            </div>
        </Skeleton>;
};
export default RatingSummary;